import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RatingComponent implements OnInit {
  @Input() public rating: number;
  @Input() public editable = false;

  @Output() public changeRating: EventEmitter<number> = new EventEmitter<number>();

  ngOnInit() {
    if (this.rating !== null) {
      this.rating = +this.rating;
    }
  }

  public onChangeRating(newRating: number): void {
    if (this.editable) {
      this.rating = newRating;
      this.changeRating.emit(this.rating);
    }
  }
}
